<template>
  <div :style="printStyle">
    <Collapse
      v-model="value"
      simple
      style="border:0"
      v-if="collapseShow"
      id="pdfDom"
      ref="exportPdf"
    >
      <Panel name="1" hide-arrow style="margin: 20px 0 0 0;border:0">
        <FormTitle :titleText="$t('Employee_Information')" />
        <Form
          :label-width="120"
          label-position="left"
          slot="content"
          style="margin: 30px 5px 0 5px"
        >
          <Row :gutter="30">
            <Col :xs="24" :sm="24" :md="12" :lg="6">
              <FormItem :label="$t('Name')"
                ><!-- 姓名 -->
                <Input
                  v-model="
                    lang == 'zh'
                      ? userinfoItem.userName
                      : userinfoItem.userEName
                  "
                  disabled
                />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="12" :lg="6">
              <FormItem :label="$t('Employee_Code')"
                ><!-- 员工号 -->
                <Input v-model="userinfoItem.empCode" disabled />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="12" :lg="6">
              <FormItem :label="$t('BU')"
                ><!-- 业务单元 -->
                <Select
                  v-model="userinfoItem.businessUnit"
                  clearable
                  style="width:100%"
                  disabled
                >
                  <Option
                    v-for="item in businessUnitList"
                    :value="item.code"
                    :key="item.code"
                    >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                  >
                </Select>
                <!-- <Input v-model="userinfoItem.businessUnit" disabled /> -->
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="12" :lg="6">
              <FormItem :label="$t('Position')"
                ><!-- 职位 -->
                <Input
                  v-model="
                    lang == 'zh'
                      ? userinfoItem.position
                      : userinfoItem.enPosition
                  "
                  disabled
                />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="12" :lg="6">
              <FormItem :label="$t('Line_Manager')"
                ><!-- 直线上级 -->
                <Input
                  v-model="
                    lang == 'zh'
                      ? userinfoItem.dirSupUserName
                      : userinfoItem.dirSupUserEName
                  "
                  disabled
                />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="12" :lg="6">
              <FormItem :label="$t('Department')"
                ><!-- 部门 -->
                <Select
                  v-model="userinfoItem.department"
                  disabled
                  style="width:100%"
                >
                  <Option
                    v-for="item in departmentList"
                    :value="item.code"
                    :key="item.code"
                    >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                  >
                </Select>
                <!-- <Input v-model="userinfoItem.department" disabled /> -->
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="12" :lg="6">
              <FormItem :label="$t('Year')"
                ><!-- 年度 -->
                <Input v-model="userinfoItem.year" disabled />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Panel>
      <Tabs
        :value="tabsValue"
        v-model="tabsValue"
        :animated="false"
        name="firsttab"
        @on-click="tabsClick"
        v-if="refresh"
      >
        <TabPane :label="$t('Objective_Setting')" name="目标设定" tab="firsttab"
          ><!-- 目标设定 -->
        </TabPane>
        <TabPane
          :label="$t('Phase_Review')"
          name="阶段回顾"
          tab="firsttab"
        ></TabPane
        ><!-- 阶段回顾 -->
        <TabPane
          :label="$t('End-Year_Review_Over')"
          name="年终总结"
          tab="firsttab"
        ></TabPane
        ><!-- 年终总结 -->
        <TabPane :label="$t('STI_Update')" name="STI更新" tab="firsttab" v-if="userinfoItem.year < 2025"
          ><!-- STI更新 -->
        </TabPane>
      </Tabs>
      <GoalSetting
        ref="GoalSetting"
        v-show="tabsValue == '目标设定'"
        @addModalWarning="addModalWarning"
        @beginTime="beginTime"
      ></GoalSetting>
      <MidTermReview
        v-show="tabsValue == '阶段回顾'"
        ref="MidTermReview"
        @beginTime="beginTime"
        @addModalWarning="addModalWarning"
        @targetRevision="targetRevision"
      ></MidTermReview>
      <YearEndSummary
        v-show="tabsValue == '年终总结'"
        ref="YearEndSummary"
        @beginTime="beginTime"
        @addModalWarning="addModalWarning"
        @targetRevision="targetRevision"
      ></YearEndSummary>
      <SITUpdate ref="SITUpdate" v-show="tabsValue == 'STI更新'" ></SITUpdate>
    </Collapse>
    <Spin size="large" fix v-if="spinShow"></Spin>
    <div class="btnRight1" v-if="collapseShow">
      <Button type="primary" class="btn" @click="getPDF()"
        ><!-- 导出PDF -->{{ $t("PB_Export_PDF") }}</Button
      >
      <Button
        type="primary"
        class="btn"
        v-if="!this.$route.query.id"
        @click="returnFirst"
        >{{ $t("Return")
        }}<!-- 返回 --></Button
      >
    </div>
    <StaffView
      ref="StaffView"
      @seemore="seemore"
      @targerClick="targerClick"
      v-if="!collapseShow"
    ></StaffView>
  </div>
</template>

<script>
import GoalSetting from "./components/MyAchievementsComponents/GoalSetting";
import MidTermReview from "./components/MyAchievementsComponents/MidTermReview";
import YearEndSummary from "./components/MyAchievementsComponents/YearEndSummary";
import SITUpdate from "./components/MyAchievementsComponents/SITUpdate";
import axios from "axios";
import StaffView from "./../../index/components/StaffView";
export default {
  components: {
    GoalSetting,
    MidTermReview,
    YearEndSummary,
    SITUpdate,
    StaffView
  },
  data() {
    return {
      value: [1],
      lastTime: null,
      userinfoItem: {},
      isHistory: false,
      tabsValue: "目标设定",
      temp: "",
      refresh: true,
      collapseShow: false,
      //切换页提醒一次
      haveWarning: false,
      //返回提醒一次
      cancelWarning: false,
      id: "",
      serialnumber: "",
      spinShow: false,
      businessUnitList: [],
      departmentList: [],
      printStyle: "",
      isSelf: false,
      chushi: false
    };
  },
  created() {
    if (this.$route.query.id) {
      this.collapseShow = true;
    }
    this.getListData();
    this.$route.query.userName
      ? (document.title = this.$route.query.userName + "-绩效表单")
      : "";
  },
  computed: {
    lang() {
      return this.$store.getters.selectLangeData;
    }
  },
  mounted() {
    if (this.$route.query.id && this.$route.query.serialnumber) {
      // this.collapseShow=true
      if (this.$route.query.achStage) {
        this.tabsValue =
          this.$route.query.achStage == "目标修订"
            ? "目标设定"
            : this.$route.query.achStage;
      }
      this.$nextTick(() => {
        this.getUserData(
          this.$route.query.serialnumber,
          this.$route.query.year
        );
        this.$refs.GoalSetting.reportId = this.$route.query.id;
        this.$refs.MidTermReview.reportId = this.$route.query.id;
        this.$refs.YearEndSummary.reportId = this.$route.query.id;
        this.$refs.SITUpdate.reportId = this.$route.query.id;

        this.$refs.GoalSetting.returnFlag = this.$route.query.returnFlag
          ? false
          : true;
        this.$refs.MidTermReview.returnFlag = this.$route.query.returnFlag
          ? false
          : true;
        this.$refs.YearEndSummary.returnFlag = this.$route.query.returnFlag
          ? false
          : true;

        this.$refs.GoalSetting.isHistory = true;
        this.$refs.MidTermReview.isHistory = true;
        this.$refs.YearEndSummary.isHistory = true;
        this.$refs.SITUpdate.isHistory = true;
        this.isHistory = true;
        this.$refs.GoalSetting.targetRevisionState
          ? (this.$refs.GoalSetting.targetRevisionState = true)
          : (this.$refs.GoalSetting.targetRevisionState = false);
      });
    } else if (!this.$route.query.serialnumber && !this.$route.query.id) {
      this.getdata(JSON.parse(sessionStorage.getItem("userInfo")).serialnumber);
    }
    if (this.$route.query.beUpdateFlag) {
      this.$refs.GoalSetting.beUpdateFlag = this.$route.query.beUpdateFlag;
    }
    if (this.$route.query.tabName) {
      this.tabsValue = "年终总结";
    }
  },
  watch: {
    tabsValue(val) {
      let obj = {
        tabsValue: this.tabsValue,
        collapseShow: this.collapseShow,
        isSelf: this.isSelf
      };
      sessionStorage.setItem("myAch", JSON.stringify(obj));
    },
    collapseShow(val) {
      let obj = {
        tabsValue: this.tabsValue,
        collapseShow: this.collapseShow,
        isSelf: this.isSelf
      };
      if (val == true) {
        this.cancelWarning = false;
      }
      sessionStorage.setItem("myAch", JSON.stringify(obj));
    },
    isSelf(val) {
      let obj = {
        tabsValue: this.tabsValue,
        collapseShow: this.collapseShow,
        isSelf: this.isSelf
      };
      sessionStorage.setItem("myAch", JSON.stringify(obj));
    }
  },
  methods: {
    beginTime(value) {
      sessionStorage.removeItem("refresh");
      if (value == "1") {
        this.isSelf = true;
        this.clearSteInterval();
      } else {
        this.isSelf = false;
        this.clearSteInterval();
      }
    },
    // 开始定时器30分钟一次
    beginSteInterval() {
      clearInterval(this.lastTime);
      this.lastTime = null;
      this.lastTime = setInterval(() => {
        this.warningModal();
      }, 1800000);
    },
    warningModal() {
      if (
        this.collapseShow &&
        this.tabsValue != "STI更新" &&
        (sessionStorage.getItem("menuId") == "S0C03" ||
          sessionStorage.getItem("menuId") == null) &&
        !sessionStorage.getItem("refresh") &&
        this.isSelf
      ) {
        this.$Modal.warning({
          title: this.$t("checkSave"),
          onOk: () => {
            // 重新记录时间
            this.clearSteInterval();
          }
        });
      } else {
        this.clearSteInterval();
      }
    },
    // 提示点击确定后 重新定时30分钟
    clearSteInterval() {
      clearInterval(this.lastTime);
      this.lastTime = null;
      // console.log("collapseShow", this.collapseShow);
      // console.log("tabsValue", this.tabsValue);
      // console.log("isSelf", this.isSelf);
      // console.log("menuId", sessionStorage.getItem("menuId"));
      // // 点击其他菜单直接返回 要清掉
      // console.log("refresh", sessionStorage.getItem("refresh"));
      if (
        this.collapseShow &&
        this.tabsValue != "STI更新" &&
        (sessionStorage.getItem("menuId") == "S0C03" ||
          sessionStorage.getItem("menuId") == null) &&
        this.isSelf &&
        !sessionStorage.getItem("refresh")
      ) {
        this.beginSteInterval();
      }
    },
    // 撤销了
    addModalWarning() {
      this.returnMubiao();
    },
    returnMubiao() {
      this.tabsValue = "目标设定";
      this.temp = "目标设定";
      if (this.$refs.GoalSetting.targetRevisionState == false) {
        this.targetRevision(false);
      } else {
        this.$refs.GoalSetting.getData(this.userinfoItem);
      }
      this.refresh = false;
      this.$nextTick(() => {
        this.refresh = true;
      });
    },
    returnFirst() {
      // 目标设定先提醒
      // &&
      // !this.cancelWarning
      if (
        this.collapseShow &&
        this.tabsValue != "STI更新" &&
        (sessionStorage.getItem("menuId") == "S0C03" ||
          sessionStorage.getItem("menuId") == null) &&
        this.isSelf
      ) {
        this.$Modal.confirm({
          title: this.$t("exitSave"),
          okText: "确定",
          cancelText: "取消",
          onOk: () => {
            this.collapseShow = false;
            this.tabsValue = "目标设定";
          },
          onCancel: () => {
            this.cancelWarning = true;
            this.clearSteInterval();
          }
        });
      } else {
        this.collapseShow = false;
        this.tabsValue = "目标设定";
      }
    },
    getListData() {
      axios.post("/achReport/selectAchReportLabelInfo", {}).then(res => {
        if (res) {
          this.departmentList = res.departmentList;
          this.businessUnitList = res.businessUnitList;
        }
      });
    },
    getPDInfo(id, serialnumber) {
      this.tabsValue = "年终总结";
      this.temp = "年终总结";
      this.getUserData1(serialnumber,id);
      this.collapseShow = true;
      this.$refs.GoalSetting.reportId = id;
      this.$refs.MidTermReview.reportId = id;
      this.$refs.YearEndSummary.reportId = id;
      this.$refs.SITUpdate.reportId = id;
      this.$refs.GoalSetting.isHistory = true;
      this.$refs.MidTermReview.isHistory = true;
      this.$refs.YearEndSummary.isHistory = true;
      this.$refs.SITUpdate.isHistory = true;
      this.isHistory = true;
      this.$refs.GoalSetting.cardHid = false;
      this.$refs.MidTermReview.cardHid = false;
      this.$refs.YearEndSummary.cardHid = false;
      this.$refs.SITUpdate.cardHid = false;
    },
    getUserData(val, year) {
      this.spinShow = true;
      year = year ? year : this.userinfoItem.year;
      axios
        .post("/achApply/selectAchApplyBasicInfo", {
          serialnumber: val,
          year: year,
          id: this.$route.query.id 
        })
        .then(res => {
          if (res) {
            this.userinfoItem = res;
            this.$refs.GoalSetting.userInfo = res;
            this.$refs.MidTermReview.userInfo = res;
            this.$refs.YearEndSummary.userInfo = res;
            this.$refs.SITUpdate.userInfo = res;
            this.$refs.GoalSetting.getData(this.userinfoItem);
            if (this.$route.query.achStage == "阶段回顾") {
              this.$nextTick(() => {
                this.$refs.MidTermReview.getData();
                this.$refs.GoalSetting.targetRevisionState = false;
              });
            } else if (this.$route.query.achStage == "年终总结") {
              this.$nextTick(() => {
                this.$refs.YearEndSummary.getData();
                this.$refs.GoalSetting.targetRevisionState = false;
              });
            } else if (this.$route.query.achStage == "STI更新") {
              this.$nextTick(() => {
                this.$refs.SITUpdate.getData();
                this.$refs.GoalSetting.targetRevisionState = false;
              });
            }
            if (this.$route.query.tabName || this.id != "") {
              this.$nextTick(() => {
                this.$refs.YearEndSummary.getData();
                this.$refs.GoalSetting.targetRevisionState = false;
              });
            }
          }
          this.spinShow = false;
        });
    },
    getUserData1(val, id) {
      this.spinShow = true;
      let year = this.userinfoItem.year;
      axios
        .post("/achApply/selectAchApplyBasicInfo", {
          serialnumber: val,
          year: year,
          id: id
        })
        .then(res => {
          if (res) {
            this.userinfoItem = res;
            this.$refs.GoalSetting.userInfo = res;
            this.$refs.MidTermReview.userInfo = res;
            this.$refs.YearEndSummary.userInfo = res;
            this.$refs.SITUpdate.userInfo = res;
            this.$refs.GoalSetting.getData(this.userinfoItem);
            if (this.$route.query.achStage == "阶段回顾") {
              this.$nextTick(() => {
                this.$refs.MidTermReview.getData();
                this.$refs.GoalSetting.targetRevisionState = false;
              });
            } else if (this.$route.query.achStage == "年终总结") {
              this.$nextTick(() => {
                this.$refs.YearEndSummary.getData();
                this.$refs.GoalSetting.targetRevisionState = false;
              });
            } else if (this.$route.query.achStage == "STI更新") {
              this.$nextTick(() => {
                this.$refs.SITUpdate.getData();
                this.$refs.GoalSetting.targetRevisionState = false;
              });
            }
            if (this.$route.query.tabName || this.id != "") {
              this.$nextTick(() => {
                this.$refs.YearEndSummary.getData();
                this.$refs.GoalSetting.targetRevisionState = false;
              });
            }
          }
          this.spinShow = false;
        });
    },
    getdata(val, year) {
      axios
        .post("/achApply/selectAchApplyBasicInfo", {
          serialnumber: val,
          year: year
        })
        .then(res => {
          if (res) {
            this.userinfoItem = res;
          }
        });
    },
    tabsClick(val) {
      if (this.isHistory) {
        this.$refs.GoalSetting.targetRevisionState = true;
      }
      if (this.tabsValue != "STI更新" && this.isSelf) {
        this.tabsValue = this.temp;
        // 时间定时器重新刷新 先清空后继续
        this.$Modal.confirm({
          title: this.$t("exitSave"),
          okText: "确定",
          cancelText: "取消",
          // 确定
          onOk: () => {
            this.temp = val;
            this.tabsValue = this.temp;
            // 切换成功 下次切换需要提醒
            // this.haveWarning = false;
            if (val == "目标设定") {
              this.tabsValue = "目标设定";
              if (this.$refs.GoalSetting.targetRevisionState == false) {
                this.targetRevision(false);
              } else {
                this.$refs.GoalSetting.getData(this.userinfoItem);
              }
            } else if (val == "阶段回顾") {
              this.$refs.MidTermReview.getData();
              this.$refs.GoalSetting.targetRevisionState
                ? (this.$refs.GoalSetting.targetRevisionState = true)
                : (this.$refs.GoalSetting.targetRevisionState = false);
            } else if (val == "年终总结") {
              this.$refs.YearEndSummary.getData();
              this.$refs.GoalSetting.targetRevisionState
                ? (this.$refs.GoalSetting.targetRevisionState = true)
                : (this.$refs.GoalSetting.targetRevisionState = false);
            } else if (val == "STI更新") {
              this.$refs.SITUpdate.getData();
              this.$refs.GoalSetting.targetRevisionState
                ? (this.$refs.GoalSetting.targetRevisionState = true)
                : (this.$refs.GoalSetting.targetRevisionState = false);
            }
          },
          // 取消
          onCancel: () => {
            // 重新记录时间
            this.clearSteInterval();
          }
        });
        // 下次就不提醒了
        // this.haveWarning = true;
      } else {
        this.temp = val;
        // 切换成功 下次切换需要提醒
        // this.haveWarning = false;
        if (val == "目标设定") {
          this.tabsValue = "目标设定";
          if (this.$refs.GoalSetting.targetRevisionState == false) {
            this.targetRevision(false);
          } else {
            this.$refs.GoalSetting.getData(this.userinfoItem);
          }
        } else if (val == "阶段回顾") {
          this.$refs.MidTermReview.getData();
          this.$refs.GoalSetting.targetRevisionState
            ? (this.$refs.GoalSetting.targetRevisionState = true)
            : (this.$refs.GoalSetting.targetRevisionState = false);
        } else if (val == "年终总结") {
          this.$refs.YearEndSummary.getData();
          this.$refs.GoalSetting.targetRevisionState
            ? (this.$refs.GoalSetting.targetRevisionState = true)
            : (this.$refs.GoalSetting.targetRevisionState = false);
        } else if (val == "STI更新") {
          this.$refs.SITUpdate.getData();
          this.$refs.GoalSetting.targetRevisionState
            ? (this.$refs.GoalSetting.targetRevisionState = true)
            : (this.$refs.GoalSetting.targetRevisionState = false);
        }
      }
      this.refresh = false;
      this.$nextTick(() => {
        this.refresh = true;
      });
    },
    targetRevision(value) {
      value ? (this.tabsValue = "目标设定") : "";
      this.$refs.GoalSetting.targetRevisionState = value;
      this.$refs.GoalSetting.targetRevision();
      this.temp = this.tabsValue;
    },

    seemore(item) {
      this.tabsValue = item.achStage;
      this.temp = this.tabsValue;
      this.userinfoItem.year = item.year;
      this.userinfoItem.serialnumber = JSON.parse(
        sessionStorage.getItem("userInfo")
      ).serialnumber;
      this.collapseShow = true;
      // 进入查看更多绩效
      // 如果 年度等于当前年度  或者 没提交过当前年度数据的时候 查询最新基本信息。如果不等于当前年度 则 不查询
      if (
        this.userinfoItem.year ==
          JSON.parse(sessionStorage.getItem("userInfo")).year ||
        !this.userinfoItem.status
      ) {
        let obj = {
          serialnumber: this.userinfoItem.serialnumber,
          year: this.userinfoItem.year
        };
        this.spinShow = true;
        axios.post("/achApply/selectAchApplyBasicInfo", obj).then(res => {
          this.userinfoItem = res;
        });
        this.spinShow = false;
      }
      this.$nextTick(() => {
        this.$refs.GoalSetting.userInfo = this.userinfoItem;
        this.$refs.MidTermReview.userInfo = this.userinfoItem;
        this.$refs.YearEndSummary.userInfo = this.userinfoItem;
        this.$refs.SITUpdate.userInfo = this.userinfoItem;
        if (item.achStage == "目标设定") {
          this.$nextTick(() => {
            this.$refs.GoalSetting.getData(this.userinfoItem);
          });
        } else if (item.achStage == "阶段回顾") {
          this.$nextTick(() => {
            this.$refs.MidTermReview.getData();
          });
        } else if (item.achStage == "年终总结") {
          this.$nextTick(() => {
            this.$refs.YearEndSummary.getData();
          });
        } else if (item.achStage == "STI更新") {
          this.$nextTick(() => {
            this.$refs.SITUpdate.getData();
          });
        }
        this.$nextTick(() => {
          this.$refs.GoalSetting.getData(this.userinfoItem);
        });
     
      });
    },
    targerClick(name, val) {
      this.beginTime("0")
      this.userinfoItem.year = val;
      this.collapseShow = true;
      this.tabsValue = name;
      this.temp = name;
      this.$nextTick(() => {
        this.$refs.GoalSetting.userInfo = this.userinfoItem;
        this.$refs.MidTermReview.userInfo = this.userinfoItem;
        this.$refs.YearEndSummary.userInfo = this.userinfoItem;
        this.$refs.SITUpdate.userInfo = this.userinfoItem;
        setTimeout(() => {
          this.tabsClick(name);
          this.$refs.GoalSetting.getData(this.userinfoItem);
        }, 500);
      });
    },
    setStyle() {
      // document.getElementsByTagName('textarea')[0].value='111111111'
      // console.log(document.getElementsByTagName('textarea')[0].value)
      // let textareaList=document.getElementsByTagName('textarea')
      // for(var i=0;i<textareaList.length;i++){
      //  document.getElementsByTagName('textarea')[i].value=document.getElementsByTagName('textarea')[i].value.replace(/\n/g,'<br/>')
      // }
      this.$store.state.inputShow = false;
      this.printStyle =
        "padding-top:10px !important;width:1920px !important;margin:0 auto !important";
    },
    async getPDF() {
      await this.setStyle();
      this.spinShow = true;
      var state = false;
      this.$refs.GoalSetting.cardHid = false;
      this.$refs.MidTermReview.cardHid = false;
      this.$refs.YearEndSummary.cardHid = false;
      this.$refs.SITUpdate.cardHid = false;
      setTimeout(() => {
        state = this.getPdf("绩效表单");
        if (state) {
          this.spinShow = false;
          this.printStyle = "";
          this.$store.state.inputShow = true;
          this.$refs.GoalSetting.cardHid = true;
          this.$refs.MidTermReview.cardHid = true;
          this.$refs.YearEndSummary.cardHid = true;
          this.$refs.SITUpdate.cardHid = true;
        }
      }, 3000);
    }
  }
};
</script>
<style lang="less" scoped>
.btnRight1 {
  flex-wrap: wrap;
  position: fixed;
  bottom: 0;
  right: 30px;
  z-index: 100;
  .btn {
    margin-right: 15px;
    margin-bottom: 15px;
  }
}
/deep/.ivu-form-label-left .ivu-form-item-label {
  font-size: 15px !important;
  color: #515a6e !important;
}
</style>

<style lang="less">
input[type="textarea"] {
  white-space: pre-wrap;
  word-wrap: break-word;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/MyAchievements.vue